import React, { useMemo, useRef } from 'react';

import ItemBody from "./ItemBody";


const ChatItemCont = ({ data, headerData }) => {
  const { message_type, message, message_data_str, message_more, attachment, web_post_hide_yn } = data;

  const refImg = useRef();

  const domContent = useMemo(() => {
    if (web_post_hide_yn === 'Y') {
      return null;
    }
    let attach = JSON.parse(attachment || '{}');

    switch (Number(message_type)) {
      case 1:   //이모티콘
        return (<ItemBody.Emoticon attach={attach} />)
      case 2:   //이미지
        return (<ItemBody.Image attach={attach} refImg={refImg} />)
      case 3:   //첨부파일
        return (<ItemBody.File attach={attach} />)
      case 12:  //시그널
        return (<ItemBody.Signal attach={attach} />)
      case 21: //채널톡
        return (<ItemBody.ChannelTalk attach={attach} message={message} message_data_str={message_data_str} message_more={message_more} headerData={headerData} />)
      default:
        return (<ItemBody.Basic attach={attach} message={message} message_data_str={message_data_str} message_more={message_more} headerData={headerData} />)
    }
  }, [message_type, message_more, message, attachment, message_data_str, headerData, web_post_hide_yn]);

  return (
    domContent
  )
}


export default ChatItemCont;